import hres89uLabels from 'assets/labels/hres89u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres89uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        remark: 'Test System',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        desc_codempap: faker.name.findName(),
        staappr: '',
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: '',
        desc_codcomp: faker.name.jobArea(),
        desc_codpos: faker.name.jobTitle(),
        codcomp: faker.lorem.word(),
        codpos: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      codcomp1: faker.finance.currencyCode(),
      codcomp2: faker.finance.currencyCode(),
      codcomp3: faker.finance.currencyCode(),
      codcomp4: faker.finance.currencyCode(),
      codcomp5: faker.finance.currencyCode(),
      codcomp6: faker.finance.currencyCode(),
      codcomp7: faker.finance.currencyCode(),
      desc_codcomp: faker.name.jobArea(),
      codpos: faker.lorem.word(),
      desc_codpos: faker.name.jobTitle(),
      numreqst: faker.random.uuid(),
      codjob: faker.lorem.word(),
      desc_codjob: faker.name.jobTitle(),
      qtyreq: faker.random.number().toString().substr(0, 1),
      codempmt: faker.lorem.word(),
      desc_codempmt: faker.name.jobArea(),
      dtereqm: moment().format('DD/MM/YYYY'),
      qtydatrqyr: faker.random.number().toString().substr(0, 1),
      qtydatrqmth: faker.random.number().toString().substr(0, 1),
      amtincom: faker.commerce.price(),
      desc_codrearq: 'Test Hres89u',
      flgrecut: '',
      desnote: 'Test Hres89u',
      flgjob: '',
      syncond1: 'Test Hres89u',
      flgcond: '',
      syncond2: 'Test Hres89u'
    }

    return {
      tab1: mockTab1
    }
  },
  dropdowns () {
    const mockCodemprc = {
      '00': '00 - นาย1 1',
      '00000000': '00000000 - นายพงษชาย วิชัยยุทธ',
      '000005': '000005 - นาย1915 18919',
      '000006': '000006 - นาย1915 18919',
      '000009': '000009 - นาย1915 18919',
      '000010': '000010 - นาย1915 18919',
      '0001': '0001 - นายทดสอบ บันทึก',
      '0001000': '0001000 - น.ส.test test',
      '000111': '000111 - นายสมชาย สมใจ',
      '000222': '000222 - นางทดสอบ ระบบระบบ',
      '000234': '000234 - นายณรงค์ พิมชัยศรี',
      '000299': '000299 - น.ส.วิไลวรรณ อิ่มแดง',
      '000999': '000999 - น.ส.ทดสอบ ระบบ',
      '002447': '002447 - นายณรงค์ พิมชัยศรี',
      '01': '01 - นายณรงค์ พิมชัยศรี',
      '0471': '0471 - น.ส.วิไลวรรณ อิ่มแดง'
    }

    return {
      codemprc: {
        en: mockCodemprc,
        th: mockCodemprc
      }
    }
  },
  detailSubmit () {
    let mockTab1 = {
      staappr: '',
      flgStaappr: '',
      approvno: '1',
      chk_appr: '',
      numseq: '1',
      dtereq: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codcomp: '',
      desc_codcomp: '',
      codpos: '',
      desc_codpos: '',
      codemprc: '',
      desc_codemprc: '',
      dtestr: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
    return {
      tab1: mockTab1
    }
  },
  approve () {
    return {
      codempid: faker.lorem.word() + ' - ',
      desc_codempid: faker.name.findName(),
      approvno: faker.random.number().toString().substr(0, 1),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      amtappr: faker.commerce.price(),
      typepay: '1',
      dtepay: moment().format('DD/MM/YYYY'),
      numperiod: faker.random.number().toString().substr(0, 1),
      dtemthpay: moment().format('DD/MM/YYYY'),
      dteyrepay: moment().format('DD/MM/YYYY'),
      codpay: '',
      staappr: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres89u/mocker.js